module.exports = __webpack_public_path__ + "static/img/bg_pop.0c8dfd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_pop.png
// module id = I3i/
// module chunks = 1